export default {
  name: 'analysisPanel',
  data() {
    return {
      glandShow: true,
      overlayShow: false,
      Thermoanalysis: false,
      TysonpolygonanalysisShow: false,
      flagCommonAnalysis: false,
      proximityAnalysis: false,
      checkSrc1: '../../../../static/image/query/check.png',
      checkSrc2: '',
      checkSrc3: '',
      checkSrc4: '',
      checkSrc5: '',
    };
  },
  components: {
  },
  mounted() {},
  created() {},
  methods: {
    openShow(type) {
      this.glandShow = false;
      this.overlayShow = false;
      this.TysonpolygonanalysisShow = false;
      this.Thermoanalysis = false;
      this.flagCommonAnalysis = false;
      this.proximityAnalysis = false;
      this.$bus.emit('spinShow', false);
      switch (type) {
        case 1:
          this.glandShow = true;
          // this.flagCommonAnalysis = true;
          this.checkSrc1 = '../../../../static/image/query/check.png';
          this.checkSrc2 = '';
          this.checkSrc3 = '';
          this.checkSrc4 = '';
          this.checkSrc5 = '';
          break;
        case 2:
          this.TysonpolygonanalysisShow = true;
          this.checkSrc2 = '../../../../static/image/query/check.png';
          this.checkSrc1 = '';
          this.checkSrc3 = '';
          this.checkSrc4 = '';
          this.checkSrc5 = '';
          break;
        case 3:
          this.Thermoanalysis = true;
          this.checkSrc3 = '../../../../static/image/query/check.png';
          this.checkSrc1 = '';
          this.checkSrc2 = '';
          this.checkSrc4 = '';
          this.checkSrc5 = '';
          break;
        case 4:
          this.flagCommonAnalysis = true;
          this.checkSrc4 = '../../../../static/image/query/check.png';
          this.checkSrc1 = '';
          this.checkSrc2 = '';
          this.checkSrc3 = '';
          this.checkSrc5 = '';
          break;
        case 5:
          this.proximityAnalysis = true;
          this.checkSrc4 = '';
          this.checkSrc1 = '';
          this.checkSrc2 = '';
          this.checkSrc3 = '';
          this.checkSrc5 = '../../../../static/image/query/check.png';
          break;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/leftmenu/analysis/analysisPanel.js